<template>
  <!-- <div class="container mx-auto p-6">
    <div class="flex items-center justify-between mb-6">
      <div>
        <h1 class="text-3xl font-bold">Inventory Management</h1>
        <p class="text-muted-foreground">Manage your inventory, resources, and track utilization</p>
      </div>
    </div> -->
    <Layout title="Inventory Management" description="Manage your inventory, resources, and track utilization">
    <!-- Tabs -->
    <div class="overflow-x-auto  ">
        <div class="d-flex gap-2 mb-2 flex-nowrap" style="min-width: max-content;">
            <button
            class="btn px-3 py-1 rounded-pill fw-semibold"
            :class="tab === 'inventory' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
            @click="tab = 'inventory'"
            >
            Inventory
            </button>

            <button
            class="btn px-3 py-1 rounded-pill fw-semibold"
            :class="tab === 'resources' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
            @click="tab = 'resources'"
            >
            Resources
            </button>

            <button
            class="btn px-3 py-1 rounded-pill fw-semibold"
            :class="tab === 'utilization' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
            @click="tab = 'utilization'"
            >
            Inventory Analysis
            </button>


            <button
            class="btn px-3 pr-5 py-2 rounded-pill fw-semibold relative"
            :class="tab === 'alerts' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
            @click="tab = 'alerts'"
            >
            Alerts
            <span
                v-show="alerts.length > 0"
                class="absolute top-0 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5"
            >
                {{ alerts.length }}
            </span>
            </button>


        </div>
    </div>
    
    <div>
      <!-- <div class="grid w-full grid-cols-4 border-b">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          @click="tab = tab.value"
          class="flex items-center gap-2 p-2 border-b-2"
          :class="tab === tab.value ? 'border-primary text-primary font-semibold' : 'border-transparent text-gray-500'"
        >
          <component :is="tab.icon" class="h-4 w-4" />
          {{ tab.label }}
        </button>
      </div> -->

      <!-- Inventory -->
      <div v-if="tab === 'inventory'" class="space-y-6 mt-0">
        <div class="flex items-center justify-between">
          <h2 class="text-2xl font-semibold">Inventory Items</h2>
          <button class="btn px-3 py-1 rounded-md bg-primary text-white flex items-center" @click="isDialogOpen=true">
            <Plus class="h-4 w-4 mr-2" /> Add Item
          </button>
        </div>

        <div class="max-h-[550px] overflow-y-auto"  >
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" >
                <div
                v-for="item in inventoryItems"
                :key="item.id"
                class="border rounded-lg shadow-sm p-4 cursor-pointer hover:shadow-lg transition"
                
                >
                <div @click="goToItem(item.id)">
                    <div class="mb-2">
                        <h3 class="text-lg font-semibold">{{ item.productName }}</h3>
                        <p class="text-sm text-gray-500">{{ item.productSegment }} • {{ item.location }}</p>
                    </div>

                    <!-- Stock Count -->
                    <div class="grid grid-cols-3 gap-2 text-center mt-4">
                        <div>
                        <div class="text-lg font-bold text-primary">{{ item.totalCount?item.totalCount :0 }}</div>
                        <div class="text-xs text-muted-foreground">Total</div>
                        </div>
                        <div>
                        <div class="text-lg font-bold text-orange-500">
                            {{ item.onHoldCount? item.onHoldCount : 0 }}
                        </div>
                        <div class="text-xs text-muted-foreground">On Hold</div>
                        </div>
                        <div>
                            <div
                                class="text-lg font-bold"
                                :class="(item.totalCount - item.onHoldCount) > 0 ? 'text-green-500' : 'text-red-500'"
                            >
                                {{ item.totalCount - item.onHoldCount }}
                            </div>
                            <div class="text-xs text-muted-foreground">
                                {{ (item.totalCount - item.onHoldCount) > 0 ? 'Free Stock' : 'Shortage' }}
                            </div>
                            </div>

                    </div>
                </div>
                <div class="flex gap-2 pt-2 border-t mt-4">
                    <button class="flex-1 border rounded px-2 py-1 text-sm" @click="openEditDialog(item)">Edit</button>
                    <button class="flex-1 border rounded px-2 py-1 text-sm" @click="downloadQrCode(item.id, item.productName)">QR Code</button>
                    <button class="flex-1 border rounded px-2 py-1 text-sm" @click="deleteInventory(item.id)">Delete</button>
                </div>
            </div>
            </div>
        </div>
             <!-- Inventory Add Modal -->
            <div v-if="isDialogOpen" class="modal fade show d-block" tabindex="-1">
                <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <form @submit.prevent="createInventory">
                    <div class="modal-header">
                    <h5 class="modal-title">Add New Inventory Item</h5>
                    <button type="button" class="btn-close" @click="closeDialog"></button>
                    </div>

                    <div class="modal-body">
                    <!-- SKU -->
                    <div class="mb-3">
                        <label for="sku" class="form-label">SKU</label>
                        <input
                        v-model="formData.SKU"
                        type="text"
                        class="form-control"
                        id="sku"
                        required
                        />
                    </div>

                    <!-- Product Name -->
                    <div class="mb-3">
                        <label for="productName" class="form-label">Product Name</label>
                        <input
                        v-model="formData.productName"
                        type="text"
                        class="form-control"
                        id="productName"
                        required
                        />
                    </div>

                    <!-- Product Segment -->
                    <div class="mb-3">
                        <label for="productSegment" class="form-label">Product Segment</label>
                        <input
                        v-model="formData.productSegment"
                        type="text"
                        class="form-control"
                        id="productSegment"
                        placeholder="e.g. Electronics, Furniture"
                        required
                        />
                    </div>
                    <div class="mb-3">
                        <label for="location" class="form-label">Storage Location</label>
                        <input
                        v-model="formData.location"
                        type="text"
                        class="form-control"
                        id="location"
                        placeholder="e.g. Ubi, Jurong West, Etc"
                        required
                        />
                    </div>

                    <div class="row">
                        <!-- Total Count -->
                        <div class="col-md-6 mb-3">
                            <label for="totalCount" class="form-label">Total Count</label>
                            <input
                            v-model.number="formData.totalCount"
                            type="number"
                            class="form-control"
                            id="totalCount"
                            required
                            />
                        </div>

                        <!-- On Hold Count -->
                        <div class="col-md-6 mb-3">
                            <label for="onHoldCount" class="form-label">On Hold Count</label>
                            <input
                            v-model.number="formData.onHoldCount"
                            type="number"
                            class="form-control"
                            id="onHoldCount"
                            required
                            />
                        </div>

                        <!-- Free Stock Count -->
                        <!-- <div class="col-md-4 mb-3">
                            <label for="freeStockCount" class="form-label">Free Stock Count</label>
                            <input
                            v-model.number="formData.freeStockCount"
                            type="number"
                            class="form-control"
                            id="freeStockCount"
                            required
                            />
                        </div> -->
                        </div>

                </div>

                    <div class="modal-footer">
                    <button class="btn btn-success d-flex align-items-center gap-2" type="submit">
                        <Plus class="h-4 w-4" />
                        Add Item
                    </button>
                    </div>
                </form>
                </div>
                </div>
            </div>
            <div v-if="isEditDialogOpen" class="modal fade show d-block" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <form @submit.prevent="updateInventory">
                    <div class="modal-header">
                    <h5 class="modal-title">Edit Inventory Item</h5>
                    <button type="button" class="btn-close" @click="closeEditDialog"></button>
                    </div>

                    <div class="modal-body">
                    <div class="mb-3">
                        <label for="editSku" class="form-label">SKU</label>
                        <input
                        v-model="editFormData.SKU"
                        type="text"
                        class="form-control"
                        id="editSku"
                        disabled
                        />
                    </div>
                    <div class="mb-3">
                        <label for="editProductName" class="form-label">Product Name</label>
                        <input
                        v-model="editFormData.productName"
                        type="text"
                        class="form-control"
                        id="editProductName"
                        required
                        />
                    </div>

                    <div class="mb-3">
                        <label for="editProductSegment" class="form-label">Product Segment</label>
                        <input
                        v-model="editFormData.productSegment"
                        type="text"
                        class="form-control"
                        id="editProductSegment"
                        required
                        />
                    </div>

                    <div class="mb-3">
                        <label for="editLocation" class="form-label">Storage Location</label>
                        <input
                        v-model="editFormData.location"
                        type="text"
                        class="form-control"
                        id="editLocation"
                        required
                        />
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                        <label for="editTotalCount" class="form-label">Total Count</label>
                        <input
                            v-model.number="editFormData.totalCount"
                            type="number"
                            class="form-control"
                            id="editTotalCount"
                            disabled=true
                            required
                        />
                        </div>
                        <div class="col-md-6 mb-3">
                        <label for="editOnHoldCount" class="form-label">On Hold Count</label>
                        <input
                            v-model.number="editFormData.onHoldCount"
                            type="number"
                            class="form-control"
                            id="editOnHoldCount"
                            disabled=true
                            required
                        />
                        </div>
                    </div>
                    </div>

                    <div class="modal-footer">
                    <button class="btn btn-primary d-flex align-items-center gap-2" type="submit">
                        <i class="bi bi-save"></i>
                        Save Changes
                    </button>
                    </div>
                </form>
                </div>
            </div>
            </div>


      </div>

      <!-- Resources -->
      <div v-if="tab === 'resources'" class="space-y-6 mt-0">
        <div class="flex items-center justify-between">
          <h2 class="text-2xl font-semibold">Resources</h2>
          <button class="btn px-3 py-1 rounded-md bg-primary text-white flex items-center" @click="isResourceDialogOpen=true">
            <Plus class="h-4 w-4 mr-2" /> Add Resource
          </button>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div v-for="resource in resources" :key="resource.id" class="border rounded-lg shadow-sm p-4">
            <div class="flex items-center justify-between mb-2">
              <h3 class="text-lg font-semibold">{{ resource.name }}</h3>
              <span
                class="px-2 py-1 rounded-full text-xs"
                :class="{
                  'bg-green-100 text-green-800': resource.status === 'Available',
                  'bg-blue-100 text-blue-800': resource.status === 'In Use',
                  'bg-red-100 text-red-800': resource.status !== 'Available' && resource.status !== 'In Use'
                }"
              >
                {{ resource.status }}
              </span>
            </div>
            <p class="text-sm text-gray-500">
              {{ resource.type }} • {{ resource.capacity || resource.quantity }} {{ resource.capacity ? 'capacity' : 'units' }}
            </p>
            <div class="text-sm text-gray-500 max-h-32 overflow-y-auto">
                <br>Notes:<br>
                {{ resource.note }}
            </div>

            <div class="mt-4 text-sm">
              <h4 class="font-semibold mb-2">Maintenance Info</h4>
              <div class="grid grid-cols-2 gap-2">
                <div>
                  <p class="text-gray-500">Last Maintenance</p>
                  <p class="font-medium">{{ formatDate(resource.lastMaintenance) }}</p>
                </div>
                <div>
                  <p class="text-gray-500">Next Maintenance</p>
                  <p class="font-medium">{{ formatDate(resource.nextMaintenance) }}</p>
                </div>
              </div>
            </div>

            <div class="flex gap-2 pt-2 border-t mt-4">
              <button class="flex-1 border rounded px-2 py-1 text-sm" @click="openResourceEditDialog(resource)">Edit</button>
              <!-- <button class="flex-1 border rounded px-2 py-1 text-sm">QR Code</button> -->
              <button class="flex-1 border rounded px-2 py-1 text-sm" @click="deleteResource(resource.id)">Delete</button>
            </div >
          </div>
        </div>
        <!-- Resource Add Modal -->
        <div v-if="isResourceDialogOpen" class="modal fade show d-block" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <form @submit.prevent="createResource">
                    <div class="modal-header">
                    <h5 class="modal-title">Add New Resource</h5>
                    <button type="button" class="btn-close" @click="closeResourceDialog"></button>
                    </div>

                    <div class="modal-body">
                    <!-- Resource Name -->
                    <div class="mb-3">
                        <label for="resourceName" class="form-label">Resource Name</label>
                        <input
                        v-model="resourceForm.name"
                        type="text"
                        class="form-control"
                        id="resourceName"
                        required
                        />
                    </div>

                    <!-- Resource Type -->
                    <div class="mb-3">
                        <label for="resourceType" class="form-label">Resource Type</label>
                        <input
                        v-model="resourceForm.type"
                        type="text"
                        class="form-control"
                        id="resourceType"
                        placeholder="e.g. Vehicle, Machine, Room"
                        required
                        />
                    </div>

                    <!-- Resource Type -->
                    <div class="mb-3">
                        <label for="resourceNote" class="form-label">Notes</label>
                        <input
                        v-model="resourceForm.note"
                        type="text"
                        class="form-control"
                        id="resourceNote"
                        placeholder="e.g. Vehicle Number, Serial number"
                        required
                        />
                    </div>


                    <!-- Resource Status -->
                    <div class="mb-3">
                        <label for="resourceStatus" class="form-label">Status</label>
                        <select
                        v-model="resourceForm.status"
                        id="resourceStatus"
                        class="form-select"
                        required
                        >
                        <option value="Available">Available</option>
                        <option value="In Use">In Use</option>
                        <option value="Unavailable">Unavailable</option>
                        </select>
                    </div>

                    <div class="row">
                        <!-- Capacity -->
                        <div class="col-md-6 mb-3">
                        <label for="capacity" class="form-label">Capacity (optional)</label>
                        <input
                            v-model.number="resourceForm.capacity"
                            type="number"
                            class="form-control"
                            id="capacity"
                            placeholder="e.g. 10"
                        />
                        </div>

                        <!-- Quantity -->
                        <div class="col-md-6 mb-3">
                        <label for="quantity" class="form-label">Quantity (optional)</label>
                        <input
                            v-model.number="resourceForm.quantity"
                            type="number"
                            class="form-control"
                            id="quantity"
                            placeholder="e.g. 5"
                        />
                        </div>
                    </div>

                    <!-- Maintenance Info -->
                    <div class="row">
                        <div class="col-md-6 mb-3">
                        <label for="lastMaintenance" class="form-label">Last Maintenance</label>
                        <input
                            v-model="resourceForm.lastMaintenance"
                            type="date"
                            class="form-control"
                            id="lastMaintenance"
                        />
                        </div>
                        <div class="col-md-6 mb-3">
                        <label for="nextMaintenance" class="form-label">Next Maintenance</label>
                        <input
                            v-model="resourceForm.nextMaintenance"
                            type="date"
                            class="form-control"
                            id="nextMaintenance"
                        />
                        </div>
                    </div>
                    </div>

                    <div class="modal-footer">
                    <button class="btn btn-success d-flex align-items-center gap-2" type="submit">
                        <Plus class="h-4 w-4" />
                        Add Resource
                    </button>
                    </div>
                </form>
                </div>
            </div>
        </div>
        <!-- Resource Edit Modal -->
        <div v-if="isResourceEditDialogOpen" class="modal fade show d-block" tabindex="-1">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <form @submit.prevent="updateResource">
                    <div class="modal-header">
                    <h5 class="modal-title">Edit Resource</h5>
                    <button type="button" class="btn-close" @click="closeResourceEditDialog"></button>
                    </div>

                    <div class="modal-body">
                    <!-- Resource Name -->
                    <div class="mb-3">
                        <label for="editResourceName" class="form-label">Resource Name</label>
                        <input
                        v-model="editResourceForm.name"
                        type="text"
                        class="form-control"
                        id="editResourceName"
                        required
                        />
                    </div>

                    <!-- Resource Type -->
                    <div class="mb-3">
                        <label for="editResourceType" class="form-label">Resource Type</label>
                        <input
                        v-model="editResourceForm.type"
                        type="text"
                        class="form-control"
                        id="editResourceType"
                        required
                        />
                    </div>

                    <!-- Notes -->
                    <div class="mb-3">
                        <label for="editResourceNote" class="form-label">Notes</label>
                        <input
                        v-model="editResourceForm.note"
                        type="text"
                        class="form-control"
                        id="editResourceNote"
                        />
                    </div>

                    <!-- Status -->
                    <div class="mb-3">
                        <label for="editResourceStatus" class="form-label">Status</label>
                        <select
                        v-model="editResourceForm.status"
                        id="editResourceStatus"
                        class="form-select"
                        required
                        >
                        <option value="Available">Available</option>
                        <option value="In Use">In Use</option>
                        <option value="Maintenance">Maintenance</option>
                        <option value="Retired">Retired</option>
                        </select>
                    </div>

                    <div class="row">
                        <!-- Capacity -->
                        <div class="col-md-6 mb-3">
                        <label for="editCapacity" class="form-label">Capacity</label>
                        <input
                            v-model.number="editResourceForm.capacity"
                            type="number"
                            class="form-control"
                            id="editCapacity"
                        />
                        </div>

                        <!-- Quantity -->
                        <div class="col-md-6 mb-3">
                        <label for="editQuantity" class="form-label">Quantity</label>
                        <input
                            v-model.number="editResourceForm.quantity"
                            type="number"
                            class="form-control"
                            id="editQuantity"
                        />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                        <label for="editLastMaintenance" class="form-label">Last Maintenance</label>
                        <input
                            v-model="editResourceForm.lastMaintenance"
                            type="date"
                            class="form-control"
                            id="editLastMaintenance"
                        />
                        </div>
                        <div class="col-md-6 mb-3">
                        <label for="editNextMaintenance" class="form-label">Next Maintenance</label>
                        <input
                            v-model="editResourceForm.nextMaintenance"
                            type="date"
                            class="form-control"
                            id="editNextMaintenance"
                        />
                        </div>
                    </div>
                    </div>

                    <div class="modal-footer">
                    <button class="btn btn-primary d-flex align-items-center gap-2" type="submit">
                        <i class="bi bi-save"></i> Save Changes
                    </button>
                    </div>
                </form>
                </div>
            </div>
        </div>


      </div>

      <!-- Utilization -->
      <div v-if="tab === 'utilization'" class="space-y-6 mt-0">
        <div class="d-flex align-items-end gap-3 flex-wrap">
          <div>
            <h2 class="text-2xl font-semibold mb-1">Utilization Report</h2>
            <div class="text-muted-foreground">
              {{ selectedProduct ? selectedProduct.productName : 'All Products' }}
            </div>
          </div>

          <div class="ms-auto" style="min-width:260px">
            <label class="form-label fw-semibold mb-1">Select Product</label>
            <select v-model="selectedProductId" class="form-select">
              <option v-for="item in inventoryItems" :key="item.id" :value="item.id">
                {{ item.productName }} ({{ item.SKU }})
              </option>
            </select>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div class="border rounded-lg p-4">
            <h3 class="font-semibold">Forecasted Inventory</h3>
            <div class="text-3xl font-bold text-primary mt-2">{{ productForecast.forecastedValue }}</div>
            <p class="text-gray-500">Expected capacity usage percentage for tomorrow.</p>
          </div>

          <div class="border rounded-lg p-4">
            <h3 class="font-semibold">Forecasted Lower Bounder</h3>
            <div class="text-3xl font-bold text-primary mt-2">{{ Math.trunc((productForecast && productForecast.lowerBound) || 0) }}</div>
            <p class="text-gray-500">Low-side demand limit; below implies underuse.</p>
          </div>

          <div class="border rounded-lg p-4">
            <h3 class="font-semibold">Forecasted Upper Bounder</h3>
            <div class="text-3xl font-bold text-primary mt-2">{{ Math.trunc((productForecast && productForecast.upperBound) || 0) }}</div>
            <p class="text-gray-500">High-side demand limit; above implies surge risk.</p>
          </div>
        </div>
        <div class="border rounded-lg p-4">
          <h3 class="font-semibold">Forecasted Explaination</h3>
          <p class="text-gray-500">{{productForecast.forecastedDesc}}</p>
        </div>
        <div class="border rounded-lg p-4">
          <div class="d-flex align-items-end justify-between gap-3 flex-wrap">
            <h3 class="font-semibold mb-0">Usage Trends</h3>

            <select
              class="form-select"
              style="max-width: 180px"
              v-model="selectedPeriod"
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
            </select>
          </div>

          <div class="mt-3" style="height: 320px;">
            <Line :data="chartData" :options="chartOptions" />
          </div>
        </div>


      </div>


      <!-- Alerts -->
      <div v-if="tab === 'alerts'" class="space-y-6 mt-0">
        <h2 class="text-2xl font-semibold">Alerts & Notifications</h2>
        <div v-for="alert in alerts" :key="alert.id" class="border rounded-lg p-4">
          <div class="flex items-start gap-3">
            <AlertTriangle
              class="h-5 w-5 mt-0.5"
              :class="{
                'text-red-500': alert.alertType === 'maintenance',
                'text-yellow-500': alert.alertType === 'understock',
                'text-blue-500': alert.alertType === 'overstock'
              }"
            />
            <div class="flex-1">
              <div class="flex items-center justify-between">
                <h3 class="font-semibold">{{ capitalize(alert.alertType) }}</h3>
                <span
                  class="px-2 py-1 rounded-full text-xs"
                  :class="{
                    'bg-red-100 text-red-800': alert.alertType === 'maintenance',
                    'bg-yellow-100 text-yellow-800': alert.alertType === 'understock',
                    'bg-blue-100 text-blue-800': alert.alertType === 'overstock'
                  }"
                >
                  {{ alert.alertType }}
                </span>
              </div>
              <p class="text-gray-500 mt-1">{{ alert.description }}</p>
            </div>
            <button class="border rounded px-2 py-1 text-sm" @click="resolveAlert(alert.id)">Resolve</button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { Plus,AlertTriangle } from "lucide-vue-next"
import Layout from '@/components/Layout.vue';
import { useToast } from 'vue-toastification'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import axios from "axios";

import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  LineElement, PointElement,
  LinearScale, CategoryScale,
  Tooltip, Legend
} from 'chart.js'

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend)


export default {
  name: "inventory",
  components: {Layout, Plus,AlertTriangle ,Line },
  data() {
    return {
        tab: "inventory",
        userID:"",
        // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app", 
        inventoryItems: [],
        resources: [],
        alerts: [],
        isDialogOpen:false,
        isEditDialogOpen:false,
        formData: {
            SKU: "",
            productName: "",
            productSegment: "",
            totalCount: 0,
            onHoldCount: 0,
            location:""
        },
        editFormData: {
            id: "",
            SKU: "",
            productName: "",
            productSegment: "",
            totalCount: 0,
            onHoldCount: 0,
            location: ""
        },
        isResourceDialogOpen: false,
        resourceForm: {
            name: "",
            type: "",
            status: "Available",
            capacity: null,
            quantity: null,
            lastMaintenance: "",
            nextMaintenance: "",
            note:"",
        },
        isResourceEditDialogOpen: false,
        editResourceForm: {
            id: "",
            name: "",
            type: "",
            status: "Available",
            capacity: null,
            quantity: null,
            lastMaintenance: "",
            nextMaintenance: "",
            note: ""
        },
        productForecast: null,
        selectedProductId:null,
        selectedPeriod: "daily",
        inventoryChartData: [],
        currentChartProductId: null,


  

    }
  },
    setup() {
    const toast = useToast()

    return {
      toast
    }
  },
    async mounted() {
      this.userID = this.$store.getters.getUserId;
      await this.checkAuthState();
    
      // 1) Fetch inventory FIRST
      try {
        await this.fetchInventory();
      } catch (e) {
        this.toast.error("Failed to load inventory");
        return; // can't continue without inventory
      }
      

      // 2) Get first productId from inventory
      const first = (this.inventoryItems && this.inventoryItems[0]) || null;
      if (first) {
        this.selectedProductId = first.id; // make sure this matches :value above
      }
     const tasks = [
        this.fetchResources(),
        this.fetchUnresolvedAlerts(),
        first ? this.fetchDailyForecastByProduct(first.id) : Promise.resolve(),
        first ? this.fetchInventoryChart(first.id) : Promise.resolve()
      ];
      await Promise.allSettled(tasks);
      const results = await Promise.allSettled(tasks);
      results.forEach((r, i) => {
        if (r.status === "rejected") {
          console.error(["fetchResources","fetchUnresolvedAlerts","fetchDailyForecastByProduct"][i], r.reason);
        }
      });
    },
    watch: {
      selectedPeriod() {
        this.fetchInventoryChart(); // uses currentChartProductId
      },
      selectedProductId(newVal) {
        if (newVal) {
          this.fetchDailyForecastByProduct(newVal)
          this.fetchInventoryChart(newVal)
        }
      }
    },

    methods: {
      async fetchInventoryChart(productId) {
        try {
          const pid = productId || this.currentChartProductId;
          if (!pid) return;

          const headers = await this.getAuthHeader();
          const res = await axios.get(`${this.apiURL}/api/inventory/chart`, {
            headers,
            params: {
              period: this.selectedPeriod,   // daily | weekly | monthly | yearly
              productID: pid                 // IMPORTANT: productID (not doc id)
            }
          });

          this.inventoryChartData = Array.isArray(res.data) ? res.data : [];
          this.currentChartProductId = pid;
        } catch (err) {
          this.inventoryChartData = [];
          if (err?.response?.data?.error) {
            this.toast.error(err.response.data.error);
          } else {
            this.toast.error("Failed to load inventory chart");
          }
        }
      },
      async fetchDailyForecastByProduct(productId = this.productID) {
        try {
          if (!productId) {
            this.toast.error("Missing product ID");
            return;
          }
          const headers = await this.getAuthHeader(); // ← you said to remember this
          const res = await axios.get(
            `${this.apiURL}/api/dailyForecast/product/${productId}`,
            { headers }
          );

          this.productForecast = res.data; // latest forecast doc (with id)
          return res.data;
        } catch (err) {
          if (err && err.response && err.response.data && err.response.data.error) {
            this.toast.error(err.response.data.error); // e.g. "Forecast not found"
          } else {
            this.toast.error("Failed to load forecast");
          }
          this.productForecast = null;
        }
      },

        capitalize(str) {
            if (!str) return ''
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        async fetchUnresolvedAlerts() {
            try {
                const headers = await this.getAuthHeader();
                const res = await axios.get(`${this.apiURL}/api/alerts`, { headers });

             
                this.alerts = res.data;
                console.log(this.alerts)
                
            } catch (err) {
                console.error("❌ Error fetching unresolved alerts:", err);
                if (err.response && err.response.data && err.response.data.error) {
                this.toast.error(err.response.data.error);
                } else {
                this.toast.error("Something went wrong while fetching alerts");
                }
            }
        },
        async resolveAlert(alertId) {
            try {
                if (!alertId) {
                this.toast.error("Alert ID is required");
                return;
                }

                const headers = await this.getAuthHeader();
                const res = await axios.put(
                `${this.apiURL}/api/alerts/${alertId}/resolve`,
                {}, // no body needed
                { headers }
                );

                if (res.data && res.data.ok) {
                this.toast.success("Alert resolved successfully");
                // refresh alerts list after resolving
                await this.fetchUnresolvedAlerts();
                } else {
                this.toast.error("Failed to resolve alert");
                }
            } catch (err) {
                console.error("❌ Error resolving alert:", err);
                if (err.response && err.response.data && err.response.data.error) {
                this.toast.error(err.response.data.error);
                } else {
                this.toast.error("Something went wrong while resolving alert");
                }
            }
        },
        async deleteResource(resourceId) {
            try {
                const headers = await this.getAuthHeader();
                const res = await axios.delete(`${this.apiURL}/api/resources/${resourceId}`, {
                headers
                });

                if (res.data && res.data.ok) {
                this.toast.success("Resource deleted successfully");
                // refresh resources list after delete
                await this.fetchResources();
                } else {
                this.toast.error("Failed to delete resource");
                }
            } catch (err) {
                console.error("❌ Error deleting resource:", err);
                if (err.response && err.response.data && err.response.data.error) {
                this.toast.error(err.response.data.error);
                } else {
                this.toast.error("Something went wrong while deleting resource");
                }
            }
        },
        openResourceEditDialog(resource) {
            this.editResourceForm = { ...resource }
            this.isResourceEditDialogOpen = true
        },
        closeResourceEditDialog() {
            this.isResourceEditDialogOpen = false
        },
        async updateResource() {
            try {
            const headers = await this.getAuthHeader()
            const { id, ...payload } = this.editResourceForm

            const res = await axios.put(`${this.apiURL}/api/resources/${id}`, payload, { headers })

            if (res.data && res.data.ok) {
                this.toast.success("Resource Updated")
                await this.fetchResources()
                this.closeResourceEditDialog()
            } else {
                this.toast.error("Failed to update resource")
            }
            } catch (err) {
            if (err.response && err.response.data && err.response.data.error) {
                this.toast.error(err.response.data.error)
            } else {
                this.toast.error("Something went wrong while updating resource")
            }
            }
        },
        closeResourceDialog() {
            this.isResourceDialogOpen = false
        },
        async createResource() {
            try {
            const headers = await this.getAuthHeader()
            await axios.post(
                `${this.apiURL}/api/resources`,
                this.resourceForm,
                { headers }
            )
            this.toast.success("Resource Created")
            this.resourceForm = {
                name: "",
                type: "",
                status: "Available",
                capacity: null,
                quantity: null,
                lastMaintenance: "",
                nextMaintenance: "", 
                note:""
            }
            this.isResourceDialogOpen = false
            // reload resources list
            await this.fetchResources()
            } catch (err) {
                if (err.response && err.response.data && err.response.data.error) {
                    this.toast.error(err.response.data.error)
                } else {
                    this.toast.error("Something went wrong while creating resource")
                }
            }
        },
        async fetchResources(filters = {}) {
            try {
                const headers = await this.getAuthHeader();

                const res = await axios.get(`${this.apiURL}/api/resources`, {
                headers,
                params: {
                    status: filters.status || "",
                    type: filters.type || "",
                    search: filters.search || ""
                }
                });

                if (res.data && res.data.ok) {
                this.resources = res.data.resources;
                console.log("✅ Resources loaded:", this.resources);
                } else {
                this.toast.error("Failed to load resources");
                }
            } catch (err) {
                console.error("❌ Error fetching resources:", err);
                if (err.response && err.response.data && err.response.data.error) {
                this.toast.error(err.response.data.error);
                } else {
                this.toast.error("Something went wrong while fetching resources");
                }
            }
            },
       openEditDialog(item) {
            this.editFormData = { ...item } // copy values
            this.isEditDialogOpen = true
        },

        closeEditDialog() {
            this.isEditDialogOpen = false
        },

        async updateInventory() {
            try {
            const headers = await this.getAuthHeader()
            const { id, ...payload } = this.editFormData

            await axios.put(
                `${this.apiURL}/api/inventory/${id}`,
                payload,
                { headers }
            )

            this.toast.success("Inventory Updated")
            await this.fetchInventory()
            this.closeEditDialog()
            } catch (err) {
            console.error("❌ Error updating inventory:", err)
            if (err.response && err.response.data && err.response.data.error) {
                this.toast.error(err.response.data.error)
            } else {
                this.toast.error("Something went wrong")
            }
            }
        },
    async downloadQrCode(itemId, itemName) {
      try {
        const headers = await this.getAuthHeader();
        const res = await axios.get(`${this.apiURL}/api/inventory/${itemId}/qrcode`, {
          headers,
          responseType: "blob" // 👈 important: so axios treats it as file
        })

        // create download link
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", `${itemName|| "inventory"}_qr.png`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.toast.success("  QR Code downloaded")
      } catch (err) {
        // console.error("❌ Error downloading QR Code:", err)
        if (err.response && err.response.data && err.response.data.error) {
          this.toast.error(err.response.data.error)
        } else {
          this.toast.error("Something went wrong generating QR Code")
        }
      }
    },
    async deleteInventory(itemId) {
      try {
        const headers = await this.getAuthHeader();
        const res = await axios.delete(`${this.apiURL}/api/inventory/${itemId}`, {
          headers
        })

        console.log("  Deleted:", res.data)
        this.toast.success("Deleted Successfully")
        // remove from local list
        // this.inventoryItems = this.inventoryItems.filter(item => item.id !== itemId)
        this.fetchInventory()
      } catch (err) {
        console.error("❌ Error deleting inventory:", err)
        if (err.response && err.response.data && err.response.data.error) {
          this.toast.error(err.response.data.error)
        } else {
          this.toast.error("Something went wrong while deleting")
        }
      }
    },
    async fetchInventory() {
      try {
        const headers = await this.getAuthHeader();
        const res = await axios.get(`${this.apiURL}/api/inventory`, {
          headers
        })

        this.inventoryItems = res.data
        console.log("  Inventory loaded:", this.inventoryItems)
      } catch (err) {
        console.error("❌ Error fetching inventory:", err)

        this.toast.error("Failed to load inventory")
        
      }
    },
    async createInventory() {
      try {
        const headers = await this.getAuthHeader();
        await axios.post(
          `${this.apiURL}/api/inventory`,
          this.formData,
          {
            headers
          }
        )

        this.toast.success("Inventory Created")
    
        this.formData = {
          SKU: "",
          productName: "",
          productSegment: "",
          totalCount: 0,
          onHoldCount: 0,
          location:""
        }
        await this.fetchInventory()
        this.closeDialog()
      } catch (err) {
        console.error("❌ Error creating inventory:", err)
        if (err.response && err.response.data && err.response.data.error) {
            this.toast.error(err.response.data.error) // e.g. SKU exists
        } else {
            this.toast.error("Something went wrong")
        }

      }
    },
    closeDialog() {
      this.isDialogOpen = false
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    goToItem(id) {
      this.$router.push(`/inventoryDetails/${id}`)
    },
    async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');
      const token = await user.getIdToken();
      return { Authorization: token };
    },
    async checkAuthState() {
      const auth = getAuth();
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            try {
              const idToken = await user.getIdToken();
              this.token = idToken;
              resolve();
            } catch (error) {
              reject(error);
            }
          } else {
            router.push("/");
            reject(new Error("No user logged in"));
          }
        });
      });
    },
  },
  computed: {
    
    normalizedInventoryChartRows() {
      // API always returns { date: <label>, totalCount: <number> }
      return (this.inventoryChartData || []).map(d => ({
        label: d.date,
        value: d.totalCount
      }));
    },
    chartData() {
      const rows = this.normalizedInventoryChartRows || []
      return {
        labels: rows.map(r => r.label),
        datasets: [
          {
            label: 'Total Count',
            data: rows.map(r => r.value),
            borderWidth: 2,
            fill: false,
            tension: 0.25,
            borderColor: '#3B82F6', // 👈 Tailwind blue-500
        backgroundColor: '#3B82F6' // dots same colour
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: 'bottom' } },
        scales: {
          y: { beginAtZero: true, ticks: { precision: 0 } }
        }
      }
    },
     selectedProduct() {
      return this.inventoryItems.find(i => i.id === this.selectedProductId) || null
    },
    utilTotals() {
      if (!this.inventoryItems || this.inventoryItems.length === 0) {
        return { total: 0, hold: 0 }
      }
      if (this.selectedProduct) {
        return {
          total: Number(this.selectedProduct.totalCount || 0),
          hold: Number(this.selectedProduct.onHoldCount || 0),
        }
      }
      // aggregate across all
      return this.inventoryItems.reduce((acc, i) => {
        acc.total += Number(i.totalCount || 0)
        acc.hold += Number(i.onHoldCount || 0)
        return acc
      }, { total: 0, hold: 0 })
    },
    freeStock() {
      return Math.max(this.utilTotals.total - this.utilTotals.hold, 0)
    },
    utilizationPct() {
      const t = this.utilTotals.total
      return t > 0 ? Math.round((this.utilTotals.hold / t) * 100) : 0
    },
  },

}
</script>
